/**
 * Per-client feature flag registry. Add an entry when this client starts
 * consuming a flag. Each value MUST match the gate name in the Statsig
 * Console and the backend registry
 * (spark/services/shared/src/shared/feature_flags/flags.py).
 *
 * IMPORTANT: Create the gate in Statsig Console BEFORE adding here.
 */
export const FeatureFlag = {
  SPLIT_SAML_DEMO_PARTIAL_SIGNATURE: 'split_saml_demo_partial_signature',
} as const;

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];
